<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";

export default {
  name: "MyTickets",
  components: {LoadingPage},

  setup(){

    let loading = ref(false)
    let tickets = ref([])


    function my_ticket() {

      loading.value = true
      FreeWorld.Heisenberg({action:'tickets'} , 'info' , true).then((res)=>{

        loading.value = false
        tickets.value = res.data

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , my_ticket)
      })

    }
    my_ticket()

    return{

    loading,
      tickets,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">تیکت های من</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-3">

      <div v-if="tickets.length === 0 && !loading" style="height: 55vh" class="animate__animated animate__fadeIn d-flex justify-content-center w-100">
        <div class="d-flex flex-column align-items-center justify-content-end">
          <img style="width: 15rem" src="../assets/img/not_my_ticket.png" class="mb-3" alt="">
          <p class="font-4 font-bold">متاسفانه تاکنون تیکتی ثبت نکرده اید!</p>
        </div>
      </div>

      <div v-else class="">
      <div v-for="item in tickets" :key="item.id" class="animate__animated animate__fadeInRight bg-white rounded-4 shadow-custom p-3 mb-3">
        <div class="d-flex align-items-center justify-content-between">
          <p class="font-4 font-bold">{{ item.title }}</p>

          <div class="d-flex align-items-center">
            <p class="font-5">{{ item.date }}</p>
            <p class="font-5 mr-2">{{ item.time }}</p>
          </div>
        </div>

        <div class="div_hr my-4"></div>

        <p class="font-4 mb-3">{{ item.description }}</p>


        <div v-if="item.answer !== null" class="">
          <div class="bg-color-light p-3 rounded-3">
            <p class="font-4 font-bold">پاسخ پشتیبانی</p>

            <div class="div_hr my-3"></div>

            <p class="font-4">{{ item.answer }}</p>
          </div>
        </div>

      </div>
      </div>

    </div>


  </div>

</template>


<style scoped>

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}


</style>